import gql from 'graphql-tag'

export const UPDATE_TICKET = gql`
  mutation updateTicket($data: TicketUpdateInput!, $id: ID!) {
    updateTicket(data: $data, where: { id: $id }) {
      id
    }
  }
`

export const NEW_UPDATE_TICKET = gql`
  mutation newUpdateTicket($data: newTicketUpdateInput!, $id: ID!) {
    newUpdateTicket(data: $data, where: { id: $id }) {
      id
    }
  }
`

export const CREATE_TICKET = gql`
  mutation createTicket($data: TicketCreateInput!) {
    createTicket(data: $data) {
      id
      ticketNumber
    }
  }
`

export const CREATE_NEW_TICKET = gql`
  mutation createNewTicket($data: newTicketCreateInput!) {
    createNewTicket(data: $data) {
      id
      ticketNumber
    }
  }
`

export const REPLY_TICKET_MODULE = gql`
  mutation ReplyTicket(
    $where: TicketWhereUniqueInput!
    $data: TicketReplyWhere
  ) {
    replyTicket(where: $where, data: $data)
  }
`
export const SEND_MESSAGE = gql`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      attachments
      chatRoomId
      createdAt
      id
      mentions {
        id
        firstName
      }
      message
      updatedAt
      sender {
        id
        firstName
      }
    }
  }
`

export const MARK_MESSAGES_AS_READ = gql`
  mutation markMessagesAsRead($chatRoomId: ID!) {
    markMessagesAsRead(chatRoomId: $chatRoomId)
  }
`
export const BULK_UPDATE_TICKETS = gql`
mutation BulkUpdateTickets($data: BulkActionInput!) {
  bulkUpdateTickets(data: $data) {
    success
    message
    updatedCount
  }
}
`;
export const IS_FEEDBACK_FORM_SUBMITTED = gql`
mutation isTicketFeedback($id: ID!) {
    isTicketFeedback(id: $id) {
      success
      message
    }
  }
`;
